import React, { Component } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

//import Charts
import StackedColumnChart from "./StackedColumnChart";

import modalimage1 from "../../assets/images/product/img-7.png";
import modalimage2 from "../../assets/images/product/img-4.png";

//import action
import { getChartsData,getAllAidListRequest,getTotalLabsListRequest,getTotalEarningsListRequest,
  getTotalComplaintsListRequest,
  getTotalFAListRequest, 
  getUserStatsListRequest 

} from "../../store/actions";

// Pages Components
import WelcomeComp from "./WelcomeComp";
import MonthlyEarning from "./MonthlyEarning";
import SocialSource from "./SocialSource";
import ActivityComp from "./ActivityComp";
import TopCities from "./TopCities";
import Earning from "./earning";
import SalesAnalytics from "./sales-analytics";
import MiniWidget from "./mini-widget";
import LatestTranaction from "./LatestTranaction";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import { success } from "toastr";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [
        {
          icon: "bx bx-copy-alt",
          title: "Orders",
          value: "1,452",
          badgeValue: "+ 0.2%",
          color: "success",
          desc: "From previous period",
        },
        {
          icon: "bx bx-archive-in",
          title: "Revenue",
          value: "PKR " + 28452 * 200,
          badgeValue: "+ 0.2%",
          color: "danger",
          desc: "From previous period",
        },
        {
          icon: "bx bx-purchase-tag-alt",
          title: "Average Price",
          value: "PKR " + 16.2 * 200,
          badgeValue: "0%",
          color: "secondary",
          desc: "Same as previous period",
        },
        {
          icon: "bx bx-archive-in",
          title: "Financial Aid Provided",
          value: "PKR " + 2006.2 * 200,
          badgeValue: "21%",
          color: "success",
          desc: "From previous period",
        },
      ],
      modal: false,
      subscribemodal: false,
      chartSeries: [],
      periodType: "yearly",
      aid:"",
      totallabs:[],
      userstats:[],
      arr:[],
      totalcomplaints:"",
      totalearning:"",
      totalfa:""
    };

    this.togglemodal.bind(this);
    this.togglesubscribemodal.bind(this);
  }

  componentDidMount() {
    const { onGetChartsData,onGetAid,onGettotallabs ,onGettotalearnings,onGettotalcomplaints,
      onGettotalfa,
      onGetuserstats,
    } = this.props;
    // setTimeout(() => this.setState({ subscribemodal: true }), 2000);
    onGetAid()
    onGettotallabs()
    this.setState({ totallabs:this.props.totallabs });
    console.log("totallabs", this.props.totallabs)  
    onGettotalcomplaints()
    this.setState({ totalcomplaints:this.props.totalcomplaints });
    onGettotalfa()
    this.setState({ totalfa:this.props.totalfa });
    console.log("totalcomplaints", this.props.totalfa)  
    onGetuserstats()
    this.setState({ userstats:this.props.userstats });
    this.setState({ arr:[this.props.userstats[3],this.props.userstats[4] ]});
    console.log("userstats", this.props.userstats)  

    onGettotalearnings()
    this.setState({ totalearning:this.props.totalearning });
    console.log("totallabs", this.props.totallabs)  

    console.log("hello", this.props.aid)   
    this.setState({ aid:this.props.aid });
    onGetChartsData("yearly");
    
  }

  togglemodal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  };

  togglesubscribemodal = () => {
    this.setState(prevState => ({
      subscribemodal: !prevState.subscribemodal,
    }));
  };

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({ ...this.state, chartSeries: this.props.chartsData , aid:this.props.aid, totallabs:this.props.totallabs,
        
    totalearning:this.props.totalearning,
    totalcomplaints:this.props.totalcomplaints,
    totalfa:this.props.totalfa,
    userstats:this.props.userstats,
    arr:[this.props.userstats[3],this.props.userstats[4] ]
  });
    }
  }

  render() {
    console.log(this.state.arr)
    return (
      <React.Fragment>
        <div className="page-content">
          {/* Meta Tag is just a way to store meta info */}
          <MetaTags>
            <title>Dashboard</title>
          </MetaTags>

          <Container fluid>
            {/* Render Breadcrumb */}
            {/* <Breadcrumbs
              title={this.props.t("Dashboards")}
              breadcrumbItem={this.props.t("Dashboard")}
            /> */}

            {/*This is the Welcome Back Section Showing Earning Etc  */}
            <Row>
              <Col xl="12">
                <WelcomeComp />
              </Col>

      <Row>
        
                 
                    {/*mimi widgets */}
                    {/* <MiniWidget reports={this.state.reports} /> */}
          <Col sm="3">
            <Card>
              <CardBody>
                <div className="d-flex align-items-center mb-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                      <i className="bx bx-archive-in" />
                    </span>
                  </div>
                  <Link to={{ pathname: `/donations` }}>
                  <h5 className="font-size-14 mb-0">Total Financial Aid</h5>
                  </Link>
                </div>
                <div className="text-muted mt-4">
                  <h4>
                    {this.state.totalfa}
                    {/* {report.color == "success" && (
                      <i className="mdi mdi-chevron-up ms-1 text-success" />
                    )}
                    {report.color == "danger" && (
                      <i className="mdi mdi-chevron-down ms-1 text-success" />
                    )}
                    {report.color == "secondary" && (
                      <i className="mdi mdi-chevron ms-1 text-success" />
                    )} */}
                    <i className="mdi mdi-chevron ms-1 text-success" />
                  </h4>
                </div>
              </CardBody>
              
            </Card>   
                  
          </Col>
          <Col sm="3">
            <Card>
              <CardBody>
                <div className="d-flex align-items-center mb-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                      <i className="bx bx-archive-in" />
                    </span>
                  </div>
                  <Link to={{ pathname: `/verifiedlabs` }}>
                  <h5 className="font-size-14 mb-0">Total Labs Registered</h5>
                  </Link>
                </div>
                <div className="text-muted mt-4">
                  <h4>
                    {this.state.totallabs[0]}
                    {/* {report.color == "success" && (
                      <i className="mdi mdi-chevron-up ms-1 text-success" />
                    )}
                    {report.color == "danger" && (
                      <i className="mdi mdi-chevron-down ms-1 text-success" />
                    )}
                    {report.color == "secondary" && (
                      <i className="mdi mdi-chevron ms-1 text-success" />
                    )} */}
                    <i className="mdi mdi-chevron ms-1 text-success" />
                  </h4>
                  <div className="d-flex">
                    <Link to={{ pathname: `/pendingverifications` }}>
                    <span className="ms-2 text-truncate">view unverified labs</span>
                    </Link>                    
                  </div>
                </div>
              </CardBody>
              
            </Card>   
                  
          </Col>
          <Col sm="3">
            <Card>
              <CardBody>
                <div className="d-flex align-items-center mb-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                      <i className="bx bx-archive-in" />
                    </span>
                  </div>
                  <Link to={{ pathname: `/accountsrecievable` }}>
                  <h5 className="font-size-14 mb-0">Total Revenue</h5>
                  </Link>
                </div>
                <div className="text-muted mt-4">
                  <h4>
                   RS. {this.state.totalearning}
                    {/* {report.color == "success" && (
                      <i className="mdi mdi-chevron-up ms-1 text-success" />
                    )}
                    {report.color == "danger" && (
                      <i className="mdi mdi-chevron-down ms-1 text-success" />
                    )}
                    {report.color == "secondary" && (
                      <i className="mdi mdi-chevron ms-1 text-success" />
                    )} */}
                    <i className="mdi mdi-chevron ms-1 text-success" />
                  </h4>
                </div>
              </CardBody>
              
            </Card>   
                  
          </Col>
          <Col sm="3">
            <Card>
              <CardBody>
                <div className="d-flex align-items-center mb-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                      <i className="bx bx-archive-in" />
                    </span>
                  </div>
                  <Link to={{ pathname: `/patientcomplaints` }}>
                  <h5 className="font-size-14 mb-0">Total Complaints Resolved</h5>
                  </Link>
                </div>
                <div className="text-muted mt-4">
                  <h4>
                    {this.state.totalcomplaints}
                    {/* {report.color == "success" && (
                      <i className="mdi mdi-chevron-up ms-1 text-success" />
                    )}
                    {report.color == "danger" && (
                      <i className="mdi mdi-chevron-down ms-1 text-success" />
                    )}
                    {report.color == "secondary" && (
                      <i className="mdi mdi-chevron ms-1 text-success" />
                    )} */}
                    <i className="mdi mdi-chevron ms-1 text-success" />
                  </h4>
                  
                </div>
              </CardBody>
              
            </Card>   
                  
          </Col>
        
       </Row>

              <Row>
              
                
                <Col xl="8">
                 
                
                    
                    {/* <SalesAnalytics 
                lab={this.state.arr}
                title1="Male"
                title2="Female" 
                title="User Analytics "
                /> */}
                <Earning 
                values={this.state.userstats}
                />
                </Col>
                

                {/* sales anytics */}
                <SalesAnalytics 
                lab={this.state.totallabs}
                title1="Verified"
                title2="Unverified"
                title="Lab Analytics"
                />
                
              </Row>
            </Row>

            <Row>
              <Col lg="12">
                <LatestTranaction />
              </Col>
            </Row>
          </Container>
        </div>

        {/* News Letter  */}
        <Modal
          isOpen={this.state.subscribemodal}
          role="dialog"
          autoFocus={true}
          data-toggle="modal"
          centered
          toggle={this.togglesubscribemodal}
        >
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <button
                type="button"
                className="btn-close"
                onClick={() => this.setState({ subscribemodal: false })}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="text-center mb-4">
                <div className="avatar-md mx-auto mb-4">
                  <div className="avatar-title bg-light  rounded-circle text-primary h1">
                    <i className="mdi mdi-email-open"></i>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <h4 className="text-primary">Subscribe !</h4>
                    <p className="text-muted font-size-14 mb-4">
                      Subscribe our newletter and get notification to stay
                      update.
                    </p>

                    <div className="input-group  rounded bg-light">
                      <Input
                        type="email"
                        className="form-control bg-transparent border-0"
                        placeholder="Enter Email address"
                      />
                      <Button color="primary" type="button" id="button-addon2">
                        <i className="bx bxs-paper-plane"></i>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* Modal to Open Up Invoices */}
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  aid: PropTypes.any,
  totallabs: PropTypes.any,
  userstats: PropTypes.any,
  totalearning: PropTypes.any,
  totalcomplaints: PropTypes.any,
  totalfa: PropTypes.any,
  onGetChartsData: PropTypes.func,
  onGetAid: PropTypes.func,
  onGettotallabs: PropTypes.func,
  onGettotalearnings: PropTypes.func,
  onGettotalcomplaints: PropTypes.func,
  onGettotalfa: PropTypes.func,
  onGetuserstats: PropTypes.func,
};

const mapStateToProps = ({ Dashboard }) => ({
  chartsData: Dashboard.chartsData,
  aid: Dashboard.aid,
  totallabs: Dashboard.totallabs,
  userstats: Dashboard.userstats,
  totalearning: Dashboard.totalearning,
  totalcomplaints: Dashboard.totalcomplaints,
  totalfa: Dashboard.totalfa,

});

const mapDispatchToProps = dispatch => ({
  onGetChartsData: periodType => dispatch(getChartsData(periodType)),
  onGetAid:() => dispatch(getAllAidListRequest()),
  onGettotallabs:() => dispatch(getTotalLabsListRequest()),
  onGettotalearnings:() => dispatch(getTotalEarningsListRequest()),
  onGettotalcomplaints:() => dispatch(getTotalComplaintsListRequest()),
  onGettotalfa:() => dispatch(getTotalFAListRequest()),
  onGetuserstats:() => dispatch(getUserStatsListRequest()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Dashboard));
